import React from 'react';
import { Provider } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished'
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';

import store from './store';
import Routes from './routes';

// Layouts
const history = createBrowserHistory();

const GlobalStyle = createGlobalStyle`
  ${ normalize() }

  *, *::before, *::after {
    box-sizing: inherit;
  }

  html {
    background-color: #fff;
    font-size: 16px;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    min-width: 300px;
    overflow-x: hidden;
    overflow-y: scroll;
    text-rendering: optimizeLegibility;
    text-size-adjust: 100%;
    box-sizing: border-box;
  }

  body {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #4a4a4a;
    font-family: BlinkMacSystemFont, -apple-system, "Roboto","Arial", sans-serif;
  }

  a {
    color: #3273dc;
    cursor: pointer;
    text-decoration: none;
  }

  figure {
    display: block;
    margin: 0;
    padding: 0;
  }

  ul {
    margin: 0;
    padding: 0;
  }
`;

const App = () => (
  <Provider store={ store }>
    <GlobalStyle />
    <Router history={history}>
      <Routes />
    </Router>
  </Provider>
);

export default App;